import React, { useRef, useEffect, useState } from 'react';
import { View, Animated, Easing, Dimensions } from 'react-native';
import svgIcons from '../../assets';
import { Icon } from '../index';
import { isMobileWidth, isNative } from '../../utils/responsive';

const { width, height } = Dimensions.get('window');

const finalHeight = isMobileWidth ? height - 80 : height;
const snowflakeCount = isMobileWidth ? 100 : 200;
const delay = 50;
const fadeOut = 200;
const lastDelay = (snowflakeCount - 1) * delay;
const random = Math.random();
const fallMin = 3000;
const fallMax = 6000;
const fallDuration = fallMin + random * fallMax;
const maxDuration = lastDelay + fallMin + fallMax;

const Snowflake = ({ delay }) => {
  const fallY = useRef(new Animated.Value(-200)).current;
  const wave = useRef(new Animated.Value(0)).current;
  const opacity = useRef(new Animated.Value(1)).current;

  const startX = Math.random() * width;
  const sideToSide = 10 + Math.random() * 25;
  // Screen height + fallY initial position
  const fallDistance = finalHeight;
  const waveDuration = 1500 + Math.random() * 3000; // 2.5–6 sec
  const size = 20 + Math.random() * 25; // icon size

  useEffect(() => {
    Animated.sequence([
      Animated.timing(fallY, {
        toValue: fallDistance,
        duration: fallDuration,
        easing: Easing.linear,
        delay,
        useNativeDriver: true,
      }),
    ]).start();

    // fade out near the end
    Animated.timing(opacity, {
      toValue: 0,
      duration: fadeOut,
      delay: delay + (fallDuration - fadeOut - fadeOut), // start fadeOut before fall ends
      useNativeDriver: true,
    }).start();

    // smooth infinite wave
    Animated.loop(
      Animated.timing(wave, {
        toValue: 1,
        duration: waveDuration,
        easing: Easing.linear,
        useNativeDriver: true,
      }),
    ).start();
  }, []);

  const driftX = wave.interpolate({
    inputRange: [0, 0.5, 1],
    outputRange: [0, sideToSide, 0],
  });

  return (
    <Animated.View
      style={{
        position: 'absolute',
        left: startX,
        opacity,
        transform: [{ translateY: fallY }, { translateX: driftX }],
      }}
    >
      <Icon
        icon={svgIcons.snowflake}
        mobileSize={{ width: size, height: size }}
        webSize={{ width: size, height: size }}
      />
    </Animated.View>
  );
};

const FallingAnimation = () => {
  const flakes = Array.from({ length: snowflakeCount }).map((_, i) => (
    <Snowflake key={i} delay={i * delay} />
  ));
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), maxDuration);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  const webWidth = width - 16;

  return (
    <View
      className="absolute overflow-hidden"
      style={{
        zIndex: 2000,
        height: finalHeight,
        width: isNative ? width : webWidth,
        left: isMobileWidth ? '0%' : '50%',
        transform: isMobileWidth ? 'none' : 'translateX(-50%)',
        top: isMobileWidth ? 0 : -80,
      }}
      pointerEvents="none"
    >
      {flakes}
    </View>
  );
};

export default FallingAnimation;
